import React from "react";
import {
  FaArrowUpRightFromSquare,
  FaGlobe,
  FaXTwitter,
  FaDiscord,
  FaTelegram,
} from "react-icons/fa6";
import AbbreviateAddress from "../../utils/abbreviateAddress";
import { SiCoinmarketcap } from "react-icons/si";
import { Link } from "react-router-dom";
import { RadarChart, DonutChart } from "@mantine/charts";
import "@mantine/charts/styles.css";
import logoLight from "../../assets/images/logo-orange-light.svg";
import logoDark from "../../assets/images/logo-orange.svg";

export const data = [
  {
    product: "Security",
    securityscore: 24.06,
  },
  {
    product: "Fundamentals",
    securityscore: 98.0,
  },
  {
    product: "Operations",
    securityscore: 86.92,
  },
  {
    product: "Decentralisation",
    securityscore: 77.9,
  },
  {
    product: "Market",
    securityscore: 85.24,
  },
  {
    product: "Community",
    securityscore: 65.95,
  },
];

const PageSecurityCode = ({ skynetRef, currentProject }) => {
  return (
    <div
      ref={skynetRef}
      id="skynet"
      className="max-w-screen flex flex-col gap-8"
    >
      <div className="grid grid-cols-12 gap-4 sm:gap-x-8">
        <div className="col-span-12 flex flex-col xl:col-span-4 lg:col-span-12">
          <div className="relative border border-neutral-20 bg-neutral-0 shadow-black-5 transition-all duration-200 dark:shadow-black-40 dark:border-neutral-80 dark:bg-neutral-100 p-6 h-full w-full">
            <div className="flex h-full max-h-[21.25rem] flex-col justify-between gap-2 text-neutral-100 dark:text-neutral-0">
              <div className="flex shrink-0 flex-wrap items-center justify-between gap-1">
                <div class="text-base font-semibold text-neutral-100 dark:text-neutral-0">
                  {currentProject?.name} Project Info
                </div>
                <div className="w-full overflow-x-hidden overflow-y-hidden min-h-0 shrink grow">
                  <div className="w-full mt-2">
                    <div className="flex flex-col gap-4">
                      <div class="flex flex-wrap items-center justify-between gap-2">
                        <div class="text-xs font-semibold text-neutral-60 dark:text-neutral-40">
                          Listed Date
                        </div>
                        <div class="text-xs font-medium text-n-100">
                          {currentProject?.date}
                        </div>
                      </div>
                      <div class="flex flex-wrap items-center justify-between gap-2">
                        <div class="text-xs font-semibold text-neutral-60 dark:text-neutral-40">
                          Website
                        </div>
                        <a
                          href="https://www.nvirworld.com/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <div class="flex items-center gap-1 truncate rounded px-1 py-0.5 font-semibold bg-neutral-10 text-neutral-100 dark:bg-neutral-90 dark:text-neutral-0 text-xs normal-case">
                            <div class="flex max-w-[10rem] cursor-pointer items-center gap-1">
                              <FaGlobe />
                              <div class="truncate text-xs font-medium">
                                nvirworld.com/
                              </div>
                              <FaArrowUpRightFromSquare className="text-neutral-50" />
                            </div>
                          </div>
                        </a>
                      </div>
                      <div class="flex flex-wrap items-center justify-between gap-2">
                        <div class="text-xs font-semibold text-neutral-60 dark:text-neutral-40">
                          Contracts
                        </div>
                        <div class="flex items-center gap-2">
                          <AbbreviateAddress
                            address={currentProject?.address}
                            network={currentProject?.network}
                          />
                        </div>
                      </div>
                      <div class="flex min-w-0 flex-wrap items-center justify-between gap-2">
                        <div class="text-xs font-semibold text-neutral-60 dark:text-neutral-40">
                          Socials
                        </div>
                        <div class="hidden min-w-0 flex-wrap gap-2 text-neutral-80 dark:text-neutral-20 lg:flex 2xl:flex xs:flex">
                          <Link
                            to="/"
                            target="_blank"
                            class="items-center bg-neutral-5 dark:bg-neutral-95 rounded-full flex p-1 justify-center opacity-80 hover:opacity-100 transition-opacity"
                          >
                            <SiCoinmarketcap
                              style={{ width: 20, height: 20 }}
                            />
                          </Link>
                          <Link
                            to="/"
                            target="_blank"
                            class="items-center bg-neutral-5 dark:bg-neutral-95 rounded-full flex p-1 justify-center opacity-80 hover:opacity-100 transition-opacity"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <rect width="24" height="24" fill="none"></rect>
                              <path
                                d="M11.9556 2.0001C6.43154 2.02602 1.97602 6.52228 2.0001 12.0444C2.02602 17.5666 6.52228 22.024 12.0444 21.9999C17.5666 21.974 22.024 17.4777 21.9999 11.9556C21.974 6.43154 17.4777 1.97602 11.9556 2.0001ZM10.6889 11.5093C9.70187 11.5093 8.90003 10.7093 8.90003 9.72224C8.90003 8.73522 9.70002 7.93522 10.6889 7.93522C11.6759 7.93522 12.4759 8.73522 12.4759 9.72224C12.4759 10.7093 11.6759 11.5093 10.6889 11.5093ZM12.1148 13.4426L12.1241 13.4315L12.1333 13.4204C12.6444 13.75 13.2259 13.8648 13.8074 13.8833C14.3907 13.8981 14.9833 13.8555 15.5685 13.737C16.1518 13.6167 16.7259 13.437 17.2796 13.2074C17.5907 13.0796 17.8999 12.9389 18.1944 12.7741C18.1962 12.7722 18.1981 12.7722 18.1999 12.7704C18.3833 12.6593 18.5629 12.5444 18.7388 12.4241C18.7777 12.3963 18.8147 12.3685 18.8499 12.3389L18.8536 12.3444L18.8685 12.363C18.4185 12.7722 17.8833 13.0759 17.3388 13.3444C16.7888 13.6037 16.2148 13.8166 15.6222 13.9704C15.0315 14.1222 14.4148 14.2389 13.7907 14.1815C13.1759 14.1241 12.5278 13.9092 12.1148 13.4426ZM16.7037 11.5093C16.7037 11.2945 16.8759 11.1222 17.0888 11.1204C17.3037 11.1204 17.4759 11.2926 17.4777 11.5056C17.4777 11.7185 17.3055 11.8944 17.0925 11.8944C16.8796 11.8963 16.7037 11.7241 16.7037 11.5093ZM13.6407 21.1018C13.2537 18.3944 15.6166 15.7444 16.95 14.3889C17.2518 14.0815 17.7203 13.6574 18.1555 13.2074C19.8851 11.5907 20.2295 9.65743 16.6888 8.69077C16.0185 8.49633 15.3222 8.22041 14.6185 7.94263C14.5963 7.87782 14.5703 7.81671 14.5426 7.7593C14.4611 7.62041 14.3203 7.4593 14.1055 7.27782C13.6444 6.87783 12.7815 6.88894 12.0352 7.06486C11.2093 6.87042 10.3963 6.8019 9.61299 6.98894C6.18895 7.93152 5.63895 9.60188 5.50562 11.6148C5.32414 13.7889 5.21858 15.4092 4.39452 17.2611C3.36675 15.7777 2.7612 13.9815 2.75379 12.0407C2.73157 6.93523 6.8519 2.77602 11.9593 2.75379C17.0666 2.73157 21.224 6.8519 21.2481 11.9593C21.2666 16.5203 17.9814 20.3258 13.6407 21.1018Z"
                                fill="currentColor"
                              ></path>
                              <path
                                d="M11.6976 9.54554C11.6976 10.2226 11.1488 10.7715 10.4717 10.7715C9.79461 10.7715 9.24573 10.2226 9.24573 9.54554C9.24573 8.86846 9.79461 8.31958 10.4717 8.31958C11.1488 8.31958 11.6976 8.86846 11.6976 9.54554Z"
                                fill="currentColor"
                              ></path>
                            </svg>
                          </Link>
                          <Link
                            to="/"
                            target="_blank"
                            class="items-center bg-neutral-5 dark:bg-neutral-95 rounded-full flex p-1 justify-center opacity-80 hover:opacity-100 transition-opacity"
                          >
                            <FaXTwitter style={{ width: 20, height: 20 }} />
                          </Link>
                          <Link
                            to="/"
                            target="_blank"
                            class="items-center bg-neutral-5 dark:bg-neutral-95 rounded-full flex p-1 justify-center opacity-80 hover:opacity-100 transition-opacity"
                          >
                            <FaDiscord style={{ width: 20, height: 20 }} />
                          </Link>
                          <Link
                            to="/"
                            target="_blank"
                            class="items-center bg-neutral-5 dark:bg-neutral-95 rounded-full flex p-1 justify-center opacity-80 hover:opacity-100 transition-opacity"
                          >
                            <FaTelegram style={{ width: 20, height: 20 }} />
                          </Link>
                        </div>
                      </div>
                      <div class="text-xs font-normal text-neutral-80 dark:text-neutral-20">
                        <div class="text-xs font-semibold text-neutral-60 dark:text-neutral-40">
                          Project Description
                        </div>
                        <div>
                          <div class="mt-2">
                            In the realm of memecoins, DOGEMOB sets itself apart
                            through its growing ecosystem, utility, and
                            community-driven appproach.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-span-12 flex min-w-0 max-w-full flex-1 flex-col gap-8 xl:col-span-8 lg:col-span-12">
          <div className="flex flex-1 flex-col">
            <div className="relative border border-neutral-20 bg-neutral-0 shadow-black-5 transition-all duration-200 dark:shadow-black-40 dark:border-neutral-80 dark:bg-neutral-100 p-6 w-full h-full">
              <div className="flex h-full flex-col gap-8 md:grid md:grid-cols-12">
                <div className="relative hidden min-h-[200px] w-full rounded-xl border border-neutral-5 bg-background-light p-4 dark:border-neutral-95 dark:bg-background-dark md:col-span-7 md:h-full xs:flex">
                  <div className="h-full w-full">
                    <RadarChart
                      h={240}
                      data={data}
                      dataKey="product"
                      series={[
                        {
                          name: "securityscore",
                          color: "orange.4",
                          opacity: 0.2,
                        },
                      ]}
                    />
                  </div>
                </div>
                <div className="col-span-12 flex flex-col justify-between gap-6 md:col-span-5">
                  <div className="flex flex-col items-center gap-3">
                    <div class="flex items-center gap-1">
                      <div class="text-sm font-semibold text-neutral-100 dark:text-neutral-0">
                        Security Score
                      </div>
                    </div>
                    <div className="w-[200px]">
                      <div class="relative h-full w-full text-score-excellent">
                        <svg width="200" height="100" class="absolute inset-0">
                          <path
                            fill="none"
                            stroke="currentColor"
                            stroke-width="5"
                            d="M5,100A90,90,0,0,1,195,100"
                            stroke-dasharray="100 100"
                            pathLength="100"
                            stroke-dashoffset="15.42"
                          ></path>
                        </svg>
                        <div class="absolute bottom-0 left-1/2 flex w-full -translate-x-1/2 flex-col items-center gap-1">
                          <div>
                            <span class="text-4xl font-medium">84</span>
                            <span class="text-[1rem] font-medium">.58</span>
                          </div>
                          <div class="flex h-5 min-w-[2.5rem] items-center justify-center rounded bg-current text-xs font-semibold">
                            <span class="text-neutral-0">
                              <span className="px-2">AUDIT PASSED</span>
                            </span>
                          </div>
                        </div>
                        <svg
                          width="200"
                          height="100"
                          class="text-score-excellent-background"
                        >
                          <path
                            fill="none"
                            stroke="currentColor"
                            stroke-width="5"
                            d="M5,100A90,90,0,0,1,195,100"
                          ></path>
                        </svg>
                        <div class="mt-1 flex justify-between text-2xs font-semibold text-neutral-30 dark:text-neutral-70">
                          <div
                            style={{ width: "10px" }}
                            class="flex justify-center"
                          >
                            0
                          </div>
                          <div
                            style={{ width: "10px" }}
                            class="flex justify-center"
                          >
                            100
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex gap-2">
                      <div class="flex w-[88px] flex-col gap-2">
                        <div class="flex flex-col items-center gap-1 border border-neutral-10 p-2 dark:border-neutral-90 w-100">
                          <span class="text-xs font-medium text-neutral-40">
                            Security
                          </span>
                          <span class="whitespace-nowrap text-sm font-semibold text-neutral-100 dark:text-neutral-0">
                            24.00
                          </span>
                        </div>
                      </div>
                      <div class="flex w-[88px] flex-col gap-2">
                        <div class="flex flex-col items-center gap-1 border border-neutral-10 p-2 dark:border-neutral-90 w-100">
                          <span class="text-xs font-medium text-neutral-40">
                            Fund.
                          </span>
                          <span class="whitespace-nowrap text-sm font-semibold text-neutral-100 dark:text-neutral-0">
                            98.00
                          </span>
                        </div>
                      </div>
                      <div class="flex w-[88px] flex-col gap-2">
                        <div class="flex flex-col items-center gap-1 border border-neutral-10 p-2 dark:border-neutral-90 w-100">
                          <span class="text-xs font-medium text-neutral-40">
                            Oper.
                          </span>
                          <span class="whitespace-nowrap text-sm font-semibold text-neutral-100 dark:text-neutral-0">
                            86.92
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="flex gap-2">
                      <div class="flex w-[88px] flex-col gap-2">
                        <div class="flex flex-col items-center gap-1 border border-neutral-10 p-2 dark:border-neutral-90 w-100">
                          <span class="flex items-center gap-1 text-xs font-medium text-neutral-50">
                            Gov.
                          </span>
                          <span class="whitespace-nowrap text-sm font-semibold text-neutral-100 dark:text-neutral-0">
                            77.90
                          </span>
                        </div>
                      </div>
                      <div class="flex w-[88px] flex-col gap-2">
                        <div class="flex flex-col items-center gap-1 border border-neutral-10 p-2 dark:border-neutral-90 w-100">
                          <span class="text-xs font-medium text-neutral-40">
                            Market
                          </span>
                          <span class="whitespace-nowrap text-sm font-semibold text-neutral-100 dark:text-neutral-0">
                            85.24
                          </span>
                        </div>
                      </div>
                      <div class="flex w-[88px] flex-col gap-2">
                        <div class="flex flex-col items-center gap-1 border border-neutral-10 p-2 dark:border-neutral-90 w-100">
                          <span class="text-xs font-medium text-neutral-40">
                            Com.
                          </span>
                          <span class="whitespace-nowrap text-sm font-semibold text-neutral-100 dark:text-neutral-0">
                            65.95
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageSecurityCode;
